(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vx-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__vxLazyVid) return; window.__vxLazyVid=1;
  function load(v){
    if(v.dataset.vxloaded) return; v.dataset.vxloaded='1';
    var url=v.getAttribute('data-vxlazy'); if(!url) return;
    var s=document.createElement('source'); s.src=url;
    s.type=url.indexOf('.webm')>-1?'video/webm':'video/mp4';
    v.appendChild(s); v.load();
    var p=v.play(); if(p&&p.catch)p.catch(function(){});
  }
  function boot(){
    var vids=[].slice.call(document.querySelectorAll('video[data-vxlazy]'));
    if(!('IntersectionObserver' in window)){ vids.forEach(load); return; }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ load(e.target); io.unobserve(e.target); } });
    },{rootMargin:'200px 0px'});
    vids.forEach(function(v){ if(!v.dataset.vxloaded) io.observe(v); });
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-feature"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__vxLazyVid) return; window.__vxLazyVid=1;
  function load(v){
    if(v.dataset.vxloaded) return; v.dataset.vxloaded='1';
    var url=v.getAttribute('data-vxlazy'); if(!url) return;
    var s=document.createElement('source'); s.src=url;
    s.type=url.indexOf('.webm')>-1?'video/webm':'video/mp4';
    v.appendChild(s); v.load();
    var p=v.play(); if(p&&p.catch)p.catch(function(){});
  }
  function boot(){
    var vids=[].slice.call(document.querySelectorAll('video[data-vxlazy]'));
    if(!('IntersectionObserver' in window)){ vids.forEach(load); return; }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ load(e.target); io.unobserve(e.target); } });
    },{rootMargin:'200px 0px'});
    vids.forEach(function(v){ if(!v.dataset.vxloaded) io.observe(v); });
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-meeting-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(sec){
    var p=sec.querySelector('.vx-mr__words'); if(!p||p.dataset.built) return; p.dataset.built='1';
    var words=(p.textContent||'').trim().split(/\s+/);
    p.innerHTML=words.map(function(w){return '<span>'+w+'</span>';}).join(' ');
    var spans=p.querySelectorAll('span');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce||window.innerWidth<=820){ spans.forEach(function(s){s.classList.add('lit');}); return; }
    var ticking=false;
    function update(){
      ticking=false;
      var r=sec.getBoundingClientRect(); var vh=window.innerHeight||1;
      var total=r.height-vh; var prog=total>0?(-r.top/total):(r.top<vh?1:0);
      prog=Math.max(0,Math.min(1,prog));
      var n=Math.floor(prog*spans.length*1.18);
      for(var i=0;i<spans.length;i++){ spans[i].classList.toggle('lit', i<n); }
    }
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    update();
  }
  function init(root){ root.querySelectorAll('.vx-mr').forEach(initSection); }
  if(document.readyState!=='loading') init(document); else document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-voice-compare"] && !Shopify.designMode) return;
  try {
    
(function(){
  function build(root){
    root.querySelectorAll('.vx-vc__kb').forEach(function(k){ if(k.children.length) return;
      for(var i=0;i<33;i++){var s=document.createElement('span'); if(i===17)s.className='hot'; k.appendChild(s);} });
    root.querySelectorAll('.vx-vc__mic').forEach(function(m){ if(m.children.length) return;
      for(var i=0;i<7;i++){var b=document.createElement('i'); b.style.animationDelay=(i*0.09)+'s'; m.appendChild(b);} });
    root.querySelectorAll('.vx-vc__text').forEach(function(el){
      if(el.dataset.started) return; el.dataset.started='1';
      var full=el.getAttribute('data-text')||''; var base=el.getAttribute('data-speed')==='fast'?40:165; var i=0;
      function step(){ el.textContent=full.slice(0,i); i++;
        if(i<=full.length){ setTimeout(step, base+Math.random()*40); }
        else { setTimeout(function(){ i=0; setTimeout(step,350); }, 2400); } }
      step();
    });
  }
  function init(root){
    var io=('IntersectionObserver' in window)?new IntersectionObserver(function(ents,obs){
      ents.forEach(function(e){ if(e.isIntersecting){ build(e.target); obs.unobserve(e.target);} });
    },{threshold:.25}):null;
    root.querySelectorAll('.vx-vc').forEach(function(sec){ io?io.observe(sec):build(sec); });
  }
  if(document.readyState!=='loading') init(document); else document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
